import { NavLink } from "react-router-dom";
const Footer = () => {
    return (
        <footer className="footer ">
            <div className="footerin">
                <div className="container px-4 px-lg-0">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-4 col-lg-4 col-xl-3 ">
                            <ul className="footer_menu pb-4 pb-md-0 mb-4 mb-md-0 pe-md-5">
                                <li className="item">
                                    <NavLink className="link" to={'/'}>Home</NavLink>
                                </li>
                                <li className="item">
                                    <NavLink className="link" to={'/about'}>About</NavLink>
                                </li>
                                <li className="item">
                                    <NavLink className="link" to={'/inprogress'}>Services</NavLink>
                                </li>
                                <li className="item">
                                    <NavLink className="link" to={'/inprogress'}>Business Lines</NavLink>
                                </li>
                                <li className="item">
                                    <NavLink className="link" to={'/contact'}>Contact</NavLink>
                                </li>
                                <li className="item">
                                    <NavLink className="link" to={'/inprogress'}>LinkedIn</NavLink>
                                </li>
                                <li className="item">
                                    <NavLink className="link" to={'/inprogress'}>Twitter</NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="col-12 col-md-8 col-lg-5 ms-lg-5">
                            <p className="text-light fs-4 mb-0">First Resource is a talent acquisition partner designed for today’s business landscape. We’re here to simplify hiring by focusing on what matters most - candidates who fit perfectly, from the start.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer;